import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyButton from "../../Components/MyButton";
import Mytitle from "../../Components/Mytitle";
import Can from "../../Components/Can";
import { Spinner } from "react-bootstrap";

const permissionLabels = {
  sub_user_create: "إضافة مستخدم فرعي",
  sub_user_show: "عرض المستخدمين الفرعيين",
  sub_user_update: "تعديل مستخدم فرعي",
  sub_user_delete: "حذف مستخدم فرعي",
  permission_update: "تعديل الصلاحيات",
  permission_show: "عرض الصلاحيات",
  subscription_show: "عرض الاشتراكات",
  salary_create: "إضافة مرتب",
  salary_show: "عرض المرتبات",
  income_statement_show: "عرض قائمة الدخل",
  account_statement_show: "عرض كشف الحساب",
  cash_report_show: "عرض تقرير الصندوق",
  service_create: "إضافة خدمة",
  service_show: "عرض الخدمات",
  service_update: "تعديل خدمة",
  service_delete: "حذف خدمة",
  money_invoice_create: "إضافة فاتورة اموال",
  money_invoice_show: "عرض فواتير الاموال",
  money_invoice_update: "تعديل إيصال مالي",
  money_invoice_delete: "حذف إيصال مالي",
  invoice_create: "إضافة فاتورة",
  invoice_show: "عرض الفواتير",
  invoice_update: "تعديل فاتورة",
  invoice_delete: "حذف فاتورة",
  expense_create: "إضافة مصروف",
  expense_show: "عرض المصروفات",
  expense_update: "تعديل مصروف",
  expense_delete: "حذف مصروف",
  employee_create: "إضافة موظف",
  employee_show: "عرض الموظفين",
  employee_update: "تعديل موظف",
  employee_delete: "حذف موظف",
  empAdjustment_create: "إضافة العمولة / الخصم",
  empAdjustment_show: "عرض العمولات والخصومات",
  empAdjustment_update: "تعديل العمولة / الخصم",
  empAdjustment_delete: "حذف العمولة / الخصم",
  customer_create: "إضافة عميل",
  customer_show: "عرض العملاء",
  customer_update: "تعديل عميل",
  customer_delete: "حذف عميل",
  category_create: "إضافة تصنيف",
  category_show: "عرض التصنيفات",
  category_update: "تعديل تصنيف",
  category_delete: "حذف تصنيف",

  owner_withdrawl_create: "إضافة مسحوبات مالك",
  owner_withdrawl_show: "إضافة مسحوبات مالك",

  setting_update: "تعديل الإعدادات",
  setting_show: "عرض الإعداداات",



  cash_transfer_create: "إضافة تحويلات نقدية",
  cash_transfer_show: "عرض التحويلات النقدية",
};


const permissionGroups = {
  المستخدمين: [
    "sub_user_create",
    "sub_user_show",
    "sub_user_update",
    "sub_user_delete",
  ],

  الصلاحيات: ["permission_show", "permission_update"],

  الموظفين: [
    "employee_create",
    "employee_show",
    "employee_update",
    "employee_delete",

  ],

  العمولةوالخصم: [
    "empAdjustment_create",
    "empAdjustment_show",
    "empAdjustment_update",
    "empAdjustment_delete",
  ],

  المرتبات: ["salary_create", "salary_show"],

  التصنيفات: [
    "category_create",
    "category_show",
    "category_update",
    "category_delete",
  ],

  الخدمات: ["service_create", "service_show", "service_update", "service_delete"],

  العملاء: [
    "customer_create",
    "customer_show",
    "customer_update",
    "customer_delete",
  ],

  الفواتير: [
    "invoice_create",
    "invoice_show",
    "invoice_update",
    "invoice_delete",
  ],

  المصروفات: ["expense_create", "expense_show", "expense_update", "expense_delete"],

  الأموال: [
    "money_invoice_create",
    "money_invoice_show",
    "money_invoice_update",
    "money_invoice_delete",

  ],

  النقدية: [
    "cash_transfer_create",
    "cash_transfer_show",
  ],

  المسحوبات: ["owner_withdrawl_create", "owner_withdrawl_show"],

  التقارير: [
    "income_statement_show",
    "account_statement_show",
    "cash_report_show",

  ],


  الإعدادات: ["setting_show", "setting_update"],

  الاشتراكات: ["subscription_show"],

};

function UserPermissions() {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [allPermissions, setAllPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userRes = await API.get(`/user-permissions/${uuid}`);
        if (userRes.data.data && userRes.data.data.length > 0) {
          setUser(userRes.data.data[0]);
          setSelectedPermissions(
            userRes.data.data[0].permissions.map((p) => p.id)
          );
        }

        const permsRes = await API.get("/permissions");
        const filtered = permsRes.data.data.filter((p) => p.type !== "system");
        setAllPermissions(filtered);
      } catch (err) {
        console.error(err);
        toast.error("فشل تحميل البيانات");
      }
    };

    fetchData();
  }, [uuid]);

  const togglePermission = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleSave = async () => {
    if (!user) return;
    setLoading(true);
    try {
      await API.post("/user-permissions", {
        uuid: user.uuid,
        permission_ids: selectedPermissions,
      });
      toast.success("تم تحديث الصلاحيات بنجاح");
      navigate("/sub-users");
    } catch (err) {
      console.error(err);
      toast.error("فشل حفظ الصلاحيات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      {allPermissions.length === 0 ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "200px" }}
        >
          <Spinner animation="border" style={{ color: "white" }} />
        </div>
      ) : (
        <>
          <Mytitle title={`صلاحيات: ${user ? user.name : ""}`} />

          <div className="card p-3">
            {Object.entries(permissionGroups).map(([groupName, perms]) => (
              <>
                <div key={groupName} className="permission-group mb-4">
                  <h5 className="group-title direction-rtl">{groupName}</h5>
                  <div className="row direction-rtl">
                    {perms
                      .map((permName) => allPermissions.find((p) => p.name === permName))
                      .filter(Boolean)
                      .map((perm) => (
                        <div key={perm.id} className="col-md-4 mb-3">
                          <div
                            className={`permission-card d-flex align-items-center gap-2 p-3 rounded cursor-pointer border ${selectedPermissions.includes(perm.id)
                              ? "selected"
                              : ""
                              }`}
                            onClick={() => togglePermission(perm.id)}
                          >
                            <input
                              type="checkbox"
                              checked={selectedPermissions.includes(perm.id)}
                              readOnly
                            />
                            <span className="pointer">{permissionLabels[perm.name] || perm.name}</span>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                <hr />
              </>
            ))}
          </div>

          <Can permission="permission_update">
            <div className="mt-3">
              <MyButton
                text="حفظ"
                variant="success"
                onClick={handleSave}
                className="mx-2"
                loading={loading}
              />
              <MyButton
                text="إلغاء"
                variant="secondary"
                className="mx-2"
                onClick={() => navigate("/sub-users")}
              />
            </div>
          </Can>
        </>
      )}
    </div>
  );

}

export default UserPermissions;
